"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _datePickerFooter = require("./datePickerFooter.style");
var _ = require("../..");
const DatePickerFooter = _ref => {
  let {
    customFooter,
    disableCancelButton,
    disableClearButton,
    disableSaveButton,
    footerType,
    onCancel,
    onReset,
    onSave
  } = _ref;
  const handleRest = e => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (onReset) {
      onReset();
    }
  };
  return (0, _jsxRuntime.jsx)(_datePickerFooter.Components.Wrapper, {
    children: footerType === 'default' ? (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_.Box, {
        children: (0, _jsxRuntime.jsx)(_.Button, {
          variant: "plain",
          type: "reset",
          label: "Clear",
          disabled: disableClearButton,
          onClick: e => handleRest(e)
        })
      }), (0, _jsxRuntime.jsxs)(_.Box, (0, _extends2["default"])({
        display: "flex"
      }, {
        children: [(0, _jsxRuntime.jsx)(_.Box, (0, _extends2["default"])({
          mr: 8
        }, {
          children: (0, _jsxRuntime.jsx)(_.Button, {
            variant: "outlined",
            label: "Cancel",
            disabled: disableCancelButton,
            onClick: onCancel
          })
        })), (0, _jsxRuntime.jsx)(_.Button, {
          label: "Save",
          disabled: disableSaveButton,
          onClick: onSave
        })]
      }))]
    }) : (0, _jsxRuntime.jsx)(_datePickerFooter.Components.DefaultFooter, {
      children: customFooter
    })
  });
};
var _default = exports["default"] = DatePickerFooter;